import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

export enum SidebarIds {
  ALARM_CENTER = 'alarmCenter',
  FILTERS = 'filters'
}

export interface Sidebar {
  open: boolean;
  id: string;
  config: {
    title: string;
    actionLabel: string;
    secondaryLabel: string;
  };
  component: any;
  inputs?: {
    [key: string]: any;
  };
  loading?: Signal<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private readonly sidebarSignal: WritableSignal<Sidebar> = signal(null);
  public sidebar = this.sidebarSignal.asReadonly();

  public open(sidebar: Sidebar): void {
    this.sidebarSignal.update(() => ({ ...sidebar, open: true }));
  }

  public updateSidebar(update: Partial<Sidebar>): void {
    this.sidebarSignal.update((current) => ({ ...current, ...update }));
  }

  public close() {
    this.sidebarSignal.update((current) => ({ ...current, open: false }));
  }
}
